define.alias("ember-math-helpers/helpers/log2", "preview-grid/helpers/log2");